import { render } from "./OrgTreePage.vue?vue&type=template&id=7ec38d04"
import script from "./OrgTreePage.vue?vue&type=script&lang=js"
export * from "./OrgTreePage.vue?vue&type=script&lang=js"

import "./org-tree.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/var/www/html/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__